import { ProfileActionTypes } from './profile.types';

export const openProfilePage = () => ({
    type: ProfileActionTypes.OPEN_PROFILE_PAGE,
});

export const closeProfilePage = () => ({
    type: ProfileActionTypes.CLOSE_PROFILE_PAGE,
});
